import Inst from './src/ContextMenuInstance'

export default Inst